module.exports = __webpack_public_path__ + "images/chargebee-icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/chargebee-icon.svg
// module id = 153
// module chunks = 1